import requestApi from '../../../apirest';

export async function getDashboardSummary(start, end) {
  const response = await requestApi(
    '/services/getDashboardSummary',
    { start, end },
    'post'
  );
  return response.data;
}
